import {Form, Input, Switch, Tabs, Button as AntButton} from 'antd';
import {Button} from '@dabafinance/react-components';
import {ArrowLeftOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {fieldRules} from 'utils/helper';
import {useQuickActionCategoryForm} from './hooks/useQuickActionCategoryForm';
import CategoryActionsTab from './CategoryActionsTab';
import styles from './quickActions.module.scss';

const QuickActionCategoryForm = () => {
  const navigate = useNavigate();
  const {
    form,
    name,
    handleTranslation,
    handleSubmit,
    loading,
    loadingCategory,
    loadingTranslation,
    isEditMode,
    categoryName,
  } = useQuickActionCategoryForm();

  if (loadingCategory) {
    return (
      <div className={styles.loading}>
        <h1>Loading...</h1>
      </div>
    );
  }

  return (
    <div className={styles.formContainer}>
      <div className={styles.formHeader}>
        <AntButton
          type="text"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate('/dashboard/quick-actions/categories')}
          className={styles.backButton}>
          Back
        </AntButton>
        <div className={styles.titleRow}>
          <h1>{isEditMode ? 'Edit Category' : 'Create Category'}</h1>
          {isEditMode && categoryName && (
            <span className={styles.nameBadge}>{categoryName}</span>
          )}
        </div>
        <p>
          {isEditMode
            ? 'Update the quick action category details'
            : 'Create a new quick action category'}
        </p>
      </div>

      <Tabs className={styles.tabs}>
        <Tabs.TabPane tab="Edit" key="edit">
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <div className={styles.sectionCard}>
              <div className={styles.translationsSection}>
                <div
                  style={{
                    display: 'flex',
                    gap: '16px',
                    alignItems: 'flex-start',
                  }}>
                  <Form.Item
                    rules={[fieldRules('Name')]}
                    label="Category Name (EN)"
                    name="name"
                    className={styles.formField}
                    style={{width: '400px'}}>
                    <Input placeholder="Enter category name" />
                  </Form.Item>
                  {name?.length > 2 && (
                    <div style={{marginTop: '30px'}}>
                      <Button
                        type="secondary"
                        disabled={loadingTranslation}
                        label={
                          loadingTranslation ? 'Translating...' : 'Translate'
                        }
                        onClick={handleTranslation}
                      />
                    </div>
                  )}
                </div>

                <Form.Item
                  label="Category Name (FR)"
                  name="nameFR"
                  className={styles.formField}
                  style={{width: '400px'}}>
                  <Input placeholder="Translated category name" />
                </Form.Item>
              </div>

              <div className={styles.switchFields} style={{marginTop: 24}}>
                <Form.Item
                  label="Active"
                  name="isActive"
                  valuePropName="checked"
                  initialValue={true}
                  className={styles.switchField}>
                  <Switch />
                </Form.Item>
              </div>
            </div>

            <Form.Item className={styles.formActions}>
              <SubmitButton
                disabled={loading}
                label={isEditMode ? 'Update Category' : 'Create Category'}
              />
            </Form.Item>
          </Form>
        </Tabs.TabPane>

        {isEditMode && (
          <Tabs.TabPane tab="Category Actions" key="actions">
            <CategoryActionsTab />
          </Tabs.TabPane>
        )}
      </Tabs>
    </div>
  );
};

export default QuickActionCategoryForm;
